import { ErrorValues, ResponseError } from './types';

export class ApiError extends Error {
  code: string;
  values: ErrorValues;

  constructor(responseError: ResponseError) {
    const message = `Error Code: ${
      responseError.code
    } - Values: ${JSON.stringify(responseError.values)}`;
    super(message);

    this.code = responseError.code;
    this.values = responseError.values;

    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
